import React from 'react';

import AgModalWindow from '@/components/common/ModalWindow/AgModalWindow';
import styles from './full-note-modal.module.scss';

interface IAddNoteModalProps {
  onClose: () => void;
  text: string;
}

export default function ViewFullNoteModal({ onClose, text }: IAddNoteModalProps) {
  return (
    <AgModalWindow
      isOpen={true}
      onClose={onClose}
      title="Full Note"
      contentStyle={{ width: 450 }}
    >
      <div className={styles.text}>
        {text}
      </div>
    </AgModalWindow>
  );
}
